<template>
    <div id="CouponPage" v-if="contentShow">
        <CouponPageBanner :order_record="order_record" />
        <div class="titleBtn">
            <div :class="btnIndex==0 ?'btnActive' :''" @click="titleBtn(0)">
                <p>可使用优惠券</p>
                <p>（{{available_total_num}}）</p>
            </div>
            <div :class="btnIndex==1 ?'btnActive' :''" @click="titleBtn(1)">
                <p>不可使用优惠券</p>
                <p>（{{notavailable_coupon}}）</p>
            </div>
        </div>
        <div class="contentDiv" v-if="btnIndex==0&&dataArr.length>0">
            <div class="itemBoxActive" @click="chooseBtn(index, item.redirect_url)" :style="index==dataArr.length-1 ?'margin-bottom:0px' :''" v-for="(item, index) in dataArr" :key='index'>
                <div class="itemTitle">
                    <div>
                        <p>￥</p>
                        <p>{{item.coupon_money}}</p>
                    </div>
                    <p v-if='item.fullMinus !== "无门槛使用"'>{{item.coupon_condition}}</p>
                    <p v-if='item.fullMinus == "无门槛使用"'>{{item.fullMinus}}</p>
                </div>
                <div class="itemContent">
                    <p>{{item.coupon_name}}</p>
                    <div class="contentClass">
                        <p>有效期：</p>
                        <p>{{item.collect_coupon_time}}-</p>
                        <p>{{item.coupon_end_time}}</p>
                    </div>
                </div>
                <div :class='chooseActive==index ?"iconDivActive iconDiv" :"iconDiv"'>
                    <i v-if='chooseActive==index' class="iconfont icon-duihao1"></i>
                </div>
            </div>
        </div>
        <div class="contentDiv" v-if="btnIndex==1&&dataArr.length>0">
            <div class="itemBox" :style="index==dataArr.length-1 ?'margin-bottom:0px' :''" v-for="(item, index) in dataArr" :key='index'>
                <div class="itemTitle">
                    <div>
                        <p>￥</p>
                        <p>{{item.coupon_money}}</p>
                    </div>
                    <p v-if='item.fullMinus !== "无门槛使用"'>{{item.coupon_condition}}</p>
                    <p v-if='item.fullMinus == "无门槛使用"'>{{item.fullMinus}}</p>
                </div>
                <div class="itemContent">
                    <p>{{item.coupon_name}}</p>
                    <div class="contentClass">
                        <p>有效期：</p>
                        <p>{{item.collect_coupon_time}}-</p>
                        <p>{{item.coupon_end_time}}</p>
                    </div>
                </div>
            </div>
        </div>
        <p class='lostText' v-if="dataArr.length==0">暂无数据</p>
        <div class="footer" v-if="btnIndex==0&&dataArr.length>0">
            <div @click="useBtn">
                <p>立即领取使用</p>
            </div>
        </div>
    </div>
</template>
<script>
import CouponPageBanner from "@/components/CouponPageBanner";
import { Toast } from 'vant';
import { URL7,URL8,URL9 } from "@/utils/Redirect";
export default {
    name:"CouponPage",
    components: {
        CouponPageBanner,
        Toast,
    },
    data() {
        return {
            availableNum: 3,
            noAvailableNum: 1,
            btnIndex: 0,
            chooseActive: -1,
            redirect_url: '',
            order_record: [],
            contentShow: false,
            available_total_num: 0,
            notavailable_coupon: 0,
            data: [],
            dataArr: [],
            LOADING_TYPE: false
        }
    },
    mounted(){
        let v_id = sessionStorage.getItem('v_id')
        let stroe_id = sessionStorage.getItem('stroe_id')
        let lq_source = sessionStorage.getItem('lq_source')
        // console.log(v_id,'-----------',stroe_id)
        // console.log(this.$route.query.from)
        let stroeId = this.$route.query.from=='CouponsPopup' ?stroe_id :v_id
        // let v_id = 2817100245
        
        this.$store.dispatch("CouponPage/Coupon", {vid: stroeId, lq_source}).then((res) => {
            if(res.code == 1000) {
                this.order_record = res.data.order_record
                this.data = res.data
                this.dataArr = this.data.available_coupon.list
                this.available_total_num = res.data.available_coupon.total_num
                this.notavailable_coupon = res.data.notavailable_coupon.total_num
                
            }else {
                Toast(JSON.stringify(res))
            }
            this.contentShow = true
        })
    },
    methods:{
        titleBtn(index) {
            this.btnIndex = index
            if(this.btnIndex == 0) {
                this.dataArr = this.data.available_coupon.list
            }else {
                this.dataArr = this.data.notavailable_coupon.list
            }
        },
        chooseBtn(index, url) {
            this.chooseActive = index
            this.redirect_url = url
        },
        useBtn() {
            if(!this.LOADING_TYPE) {
                this.LOADING_TYPE = true
                if(this.chooseActive == -1) {
                    Toast("请选择优惠券")
                    this.LOADING_TYPE = false
                }else {
                    let v_id = sessionStorage.getItem('v_id')
                    let stroe_id = sessionStorage.getItem('stroe_id')
                    
                    let stroeId = this.$route.query.from=='CouponsPopup' ?stroe_id :v_id
                    console.log(stroeId)
                    let chooseName = this.dataArr[this.chooseActive].coupon_name
                    let data = {
                        page_from:'main_page',
                        page_name:'CouponPage',
                        btn_name: `${chooseName}立即领取使用`,
                        page_time:'0.00',
                        receiver_id: '',
                        vid: stroeId,
                        page_param:{},
                    };
                    this.$store.dispatch('Public/inH5Record', data).then(res=> {
                        window.location.href= this.redirect_url
                        this.LOADING_TYPE = false
                    })
                }
            }
            
            
        },
        
    },
    
}
</script>
<style lang="scss" scoped>
    @import './index.scss';
</style>